import axiosInstance from '../../lib/api/axiosInstance';
import { EmailMessage, GmailLabel } from '../../types';

/**
 * Récupère les emails récents de l'utilisateur
 */
export const getRecentEmails = async (maxResults = 20, query = ''): Promise<EmailMessage[]> => {
  try {
    const params: Record<string, any> = { maxResults };
    
    if (query) {
      params.q = query;
    }
    
    const response = await axiosInstance.get<{ emails: EmailMessage[] }>('/google/gmail/messages', { params });
    return response.data.emails || [];
  } catch (error) {
    console.error("Erreur lors de la récupération des emails:", error);
    throw error;
  }
};

/**
 * Récupère la liste des labels Gmail de l'utilisateur
 */
export const getGmailLabels = async (): Promise<GmailLabel[]> => {
  try {
    const response = await axiosInstance.get<{ labels: GmailLabel[] }>('/google/gmail/labels');
    return response.data.labels || [];
  } catch (error) {
    console.error('Erreur lors de la récupération des labels Gmail:', error);
    throw error;
  }
};

/**
 * Déplace des emails vers un dossier spécifique
 */
export const moveEmailsToFolder = async (emailIds: string[], labelId: string): Promise<{ success: boolean }> => {
  try {
    const response = await axiosInstance.post<{ success: boolean }>('/google/gmail/move-to-folder', {
      emailIds,
      labelId
    });
    
    return response.data;
  } catch (error) {
    console.error('Erreur lors du déplacement des emails:', error);
    throw error;
  }
};

/**
 * Associe un email à une tâche existante
 */
export const associateEmailWithTask = async (
  emailId: string,
  taskId: string | number,
  emailSubject?: string
): Promise<boolean> => {
  try {
    await axiosInstance.post('/google/gmail/link-task', {
      emailId,
      taskId,
      emailSubject
    });
    
    return true;
  } catch (error) {
    console.error("Erreur lors de l'association de l'email:", error);
    throw error;
  }
};

/**
 * Récupère les labels associés à un thread/conversation
 */
export const getThreadLabels = async (threadId: string): Promise<string[]> => {
  try {
    const response = await axiosInstance.get<{ labels: string[] }>(`/google/gmail/threads/${threadId}/labels`);
    return response.data.labels || [];
  } catch (error) {
    console.error('Erreur lors de la récupération des labels du thread:', error);
    return [];
  }
};
